<template>
  <div class="global-uploader">
    <uploader
      ref="uploader"
      :options="options"
      :autoStart="true"
      @file-added="onFileAdded"
      @file-success="onFileSuccess"
      @file-progress="onFileProgress"
      @file-error="onFileError"
      class="uploader"
    >
      <uploader-unsupport></uploader-unsupport>
      <uploader-btn class="global-uploader-btn" ref="uploadBtn" :style="btnStyle">选择文件</uploader-btn>

      <uploader-list v-show="panelShow">
        <div class="file-panel" slot-scope="props">
          <div class="file-list">
            <a-row v-for="file in props.fileList" :key="file.id">
              <uploader-file :class="'file_' + file.id" ref="files" :file="file" :list="true"></uploader-file>
            </a-row>
          </div>
        </div>
      </uploader-list>
    </uploader>
    <div style="margin: 8px 0" v-show="showUploadList">
      <a-row v-for="(item, index) in fileList" :key="index">
        <a-col :span="18" style="overflow: hidden;text-overflow:ellipsis;white-space: nowrap;" :title="item.fileName">{{
          item.fileName
        }}</a-col>
        <a-col :span="2" @click="deleteFile(index)"><a-icon type="close" style="fontSize:12px"/></a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { axios } from '@/utils/request'

export default {
  name: 'GlobalUploader',
  props: {
    fileType: Number,
    showUploadList: Boolean, // 是否需要展示列表
    acceptList: Array, // 支持上传的文件类型
    alertMsg: String // 不支持时的报错信息
  },
  data () {
    const chunkSize = 10 * 1024 * 1024
    const noChunkUrl = this.$sysInfo.apiRemote + '/upload/resume?chunk=-1'
    const chunkUrl = this.$sysInfo.apiRemote + '/upload/resume?chunk='
    const Authorization = this.$store.state.user.token

    return {
      fileList: [],
      options: {
        target (file, chunk) {
          let url
          if (file.size < chunkSize) {
            url = noChunkUrl
          } else {
            url = chunkUrl + chunk.offset
          }
          return url
        },
        duplicate: true,
        // target: global.ipconfig + 'exam/import?trainId=' + this.trainId + '&id=' + this.paperId,
        singleFile: false,
        chunkSize: chunkSize, // 分块大小
        fileParameterName: 'file', // 上传文件时文件的参数名，默认为file
        maxChunkRetries: 3, // 最大自动失败重试上传次数
        testChunks: false, // 是否开启服务器分片校验
        // 服务器分片校验函数，秒传及断点续传基础
        // checkChunkUploadedByResponse: (chunk, message) => {
        //     let objMessage = JSON.parse(message);
        // if(objMessage.skipUpload) {
        //     return true;
        // }
        // return (objMessage.uploaded || []).indexOf(chunk.offset + 1) >= 0
        // },
        headers: {
          Authorization: Authorization
        }
        // withCredentials: true
      },
      // attrs: {
      //     accept: ['.pdf']
      // },
      panelShow: false, // 选择文件后，展示上传面板
      btnStyle: 'border-radius: 4px;border: 1px solid rgba(0, 0, 0, 0.2);padding: 5px 15px;'
    }
  },
  computed: {
    uploader () {
      return this.$refs.uploader.uploader
    }
  },
  mounted () {},
  methods: {
    // 清空文件上传记录
    clearFileList () {
      this.fileList = []
      this.$refs.uploader.fileList = []
    },
    onFileAdded (file, event) {
      this.panelShow = true
    },
    onFileSuccess (rootFile, file, response, chunk) {
      // console.log(rootFile, file, response, chunk)

      if (this.acceptList) {
        if (this.acceptList.indexOf(file.name.split('.')[file.name.split('.').length - 1]) === -1) {
          this.$refs.uploader.fileList.map((item, index) => {
            if (item.id === file.id) {
              this.$refs.uploader.fileList.splice(index, 1)
            }
          })
          this.$message.error(this.alertMsg)
          return
        }
      }

      const res = JSON.parse(response)

      // console.log('res', res)
      if (res.status === 0) {
        var newFile = {
          fileName: file.name
        }
        if (chunk.total > this.options.chunkSize) {
          const totalChunk = chunk.offset + 1
          axios({
            url: this.$sysInfo.apiRemote + '/upload/resume/merge?fileName=' + file.name + '&totalChunk=' + totalChunk,
            method: 'POST'
          }).then(res => {
            if (res.status === 0) {
              // file.filePath = res.data
              newFile.filePath = res.data
              this.fileList.push(newFile)
              this.$refs.uploader.fileList.map((item, index) => {
                if (item.id === file.id) {
                  this.$refs.uploader.fileList.splice(index, 1)
                }
              })
              // this.panelShow = false
              // this.$emit('newFile', newFile)
              // this.uploader.removeFile(file)
              this.$emit('handleUpload', this.fileList)
            }
          })
        } else {
          // file.filePath = res.data
          newFile.filePath = res.data
          this.fileList.push(newFile)
          this.$refs.uploader.fileList.map((item, index) => {
            if (item.id === file.id) {
              this.$refs.uploader.fileList.splice(index, 1)
            }
          })

          this.$emit('handleUpload', this.fileList)
        }
        // console.log('file', file, this.$refs.uploader.fileList)
        // console.log('******', this.fileList)
      } else {
        this.$message.error(res.info.message)
      }
    },
    onFileProgress (rootFile, file, chunk) {
      // console.log(rootFile, file, chunk)
    },
    onFileError (rootFile, file, response, chunk) {
      const res = JSON.parse(response)
      this.$message.error(res.info.message)
      this.$refs.uploader.fileList.map((item, index) => {
        if (item.id === file.id) {
          this.$refs.uploader.fileList.splice(index, 1)
        }
      })
      // this.panelShow = false
    },
    // getType() {
    //     console.log("this",this.fileType)
    // }
    deleteFile (index) {
      this.fileList.splice(index, 1)
      this.$emit('handleUpload', this.fileList)
    }
  }
}
</script>
